// extracted by mini-css-extract-plugin
export var border = "_i-7";
export var brand = "_i-s";
export var button = "_i-k";
export var center = "_i-9";
export var centered = "_i-5";
export var closeButton = "_i-b";
export var disabledWrapper = "_i-l";
export var error = "_i-o";
export var extraLarge = "_i-4";
export var extraSmall = "_i-1";
export var fill = "_i-h";
export var footer = "_i-g";
export var footerAction = "_i-i";
export var footerButtons = "_i-j";
export var header = "_i-6";
export var headerWithClose = "_i-c";
export var icon = "_i-n";
export var info = "_i-r";
export var inline = "_i-8";
export var large = "_i-3";
export var main = "_i-d";
export var modal = "_i-0";
export var neutral = "_i-t";
export var noPadding = "_i-f";
export var none = "_i-u";
export var scrollable = "_i-e";
export var small = "_i-2";
export var success = "_i-q";
export var tight = "_i-m";
export var titleIcon = "_i-a";
export var warn = "_i-p";